import { useCallback, useState } from 'react';
import { DirectCampaignUI } from '../../../../data-layer/direct/types';

export const usePromotionUtm = (company?: DirectCampaignUI) => {
    const [utmParams, setUtmValue] = useState<string | undefined>(company?.utmParams);

    const onChangeUtm = useCallback((value?: string) => {
        setUtmValue(value);
    }, []);

    return {
        utmParams,
        onChangeUtm,
    };
};
